var map = {
	"./base.js": "b500",
	"./boundary.js": "dc44",
	"./extrusion.js": "bfa1",
	"./heatmap.js": "4446",
	"./line.js": "4f41",
	"./point.js": "cf8d",
	"./region.js": "1f53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4995";